import { FaBell, FaEnvelope } from "react-icons/fa6";
import { Link } from "react-router-dom";

const NotificationMenuOptions = ({mostrarAlertas, isActivePath}) => {
  return (
    <>
      <Link
        to="/admin/chat"
        aria-label="Mensajes"
        className={`align-center ${
          isActivePath("/admin/chat") ? "activo" : "negro"
        }`}
      >
        <FaEnvelope />
      </Link>

      <Link
        to="/admin/notificaciones"
        aria-label="Notificaciones"
        className={`align-center ${
          isActivePath("/admin/notificaciones") ? "activo" : "negro"
        } ${mostrarAlertas ? "notificacion-alerta" : ""}`}
      >
        <FaBell />
      </Link>
    </>
  );
};

export default NotificationMenuOptions;
